(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["campvaro-climate-advisor-v1"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root||root.dataset.cvInit)return;root.dataset.cvInit='1';
    var form=root.querySelector('.cv-ca__form'),result=root.querySelector('.cv-ca__result'),steps=[].slice.call(root.querySelectorAll('.cv-ca-step')),idx=0,products={};
    try{products=JSON.parse(root.querySelector('script[type="application/json"]').textContent);}catch(e){}
    function show(i){idx=i;steps.forEach(function(s,n){s.classList.toggle('is-active',n===i)});root.querySelector('.cv-ca-prev').disabled=i===0;root.querySelector('.cv-ca-next').textContent=i===steps.length-1?'Bekijk mijn advies':'Volgende';root.querySelector('.cv-ca__progress span').style.width=((i+1)/steps.length*100)+'%'}
    function valid(){return !!steps[idx].querySelector('input:checked')}
    function val(n){var x=form.querySelector('[name="'+n+'"]:checked');return x?x.value:null}
    function card(k,label){var p=products[k];if(!p)return '<div class="cv-ca-product"><div><strong>'+label+'</strong><br><small>Koppel dit product in de Theme Editor.</small></div></div>';return '<div class="cv-ca-product">'+(p.image?'<img src="'+p.image+'" alt="">':'')+'<div><strong>'+label+'</strong><br><a class="button" href="'+p.url+'">Bekijk product</a></div></div>'}
    function altReason(k){return {rta1700:'Compactere 230V-keuze voor voertuigen tot 7 meter wanneer extra koelreserve niet nodig is.',rta2200:'Meer koelreserve voor grotere voertuigen, hoge zonbelasting of intensiever gebruik; geschikt tot 8 meter.',rta12v:'12V-alternatief wanneer onafhankelijk koelen zonder aparte 230V-omvormer voor de airco belangrijk is.'}[k]||''}
    function advise(){
      var use=val('use'),power=val('power'),length=val('length'),heat=val('heat'),load=val('load'),ind=val('independence'),roof=val('roof');
      var primary=null,alts=[],profile='',reason=[],warn=[];
      var wants12=(power==='12'||ind==='high'||use==='offgrid');
      var wants230=(power==='230'||use==='camping'||ind==='low');
      var highDemand=(length==='large'||heat==='hot'||load==='heavy'||(heat==='warm'&&load!=='light'));

      if(length==='xl'){
        profile='Persoonlijke klimaatcheck';
        warn.push('Je voertuig is langer dan 8 meter. De drie geselecteerde CampVaro-modellen vallen buiten hun opgegeven voertuiglengte of vragen een individuele beoordeling.');
      } else if(wants12 && !wants230){
        profile='Off-Grid Climate 12V';
        primary='rta12v';
        reason.push('Koelen zonder afhankelijk te zijn van 230V is voor jouw profiel doorslaggevend. De RTA-2000 12V sluit rechtstreeks op het 12V-boordsysteem aan en heeft geen omvormer nodig voor de airco.');
        if(length==='large') warn.push('De RTA-2000 12V is door Mestic opgegeven voor voertuigen tot 7 meter; bij 7–8 meter adviseren we geen automatische match.');
      } else if(power==='both'||(wants12&&wants230)){
        if(ind==='high'||use==='offgrid'){profile='Flexible Off-Grid Climate';primary='rta12v';reason.push('Je wilt flexibiliteit, maar onafhankelijk koelen weegt het zwaarst. Daarom krijgt de 12V-oplossing voorrang.');}
        else {profile='Premium Climate 230V';primary=highDemand?'rta2200':'rta1700';reason.push('Je gebruikt de airco vooral waar 230V beschikbaar is. Daardoor is een 230V-inverterdakairco de meest logische hoofdroute.');}
      } else {
        profile=highDemand?'High-Capacity Climate 230V':'Compact Climate 230V';
        primary=highDemand?'rta2200':'rta1700';
        reason.push('Voor jouw gebruik is 230V normaal beschikbaar, waardoor een 230V-inverterdakairco de meest logische en praktische route is.');
      }

      if(primary==='rta1700') reason.push('De RTA-1700i levert circa 1.710 W koelvermogen en is bedoeld voor voertuigen tot 7 meter.');
      if(primary==='rta2200') reason.push('De RTA-2200i levert circa 2.215 W koelvermogen en biedt extra koelreserve voor voertuigen tot 8 meter.');
      if(primary==='rta12v') reason.push('De RTA-2000 12V heeft twee vermogensstanden van circa 1.230 W en 2.020 W en is bedoeld voor voertuigen tot 7 meter.');

      if(primary==='rta1700') alts=highDemand?['rta2200','rta12v']:['rta2200','rta12v'];
      if(primary==='rta2200') alts=['rta1700','rta12v'];
      if(primary==='rta12v') alts=highDemand?['rta2200','rta1700']:['rta1700','rta2200'];

      if(roof!=='yes') warn.push('Controleer vóór bestelling dakopening, beschikbare dakruimte, dakdikte, draagkracht en montagepositie.');
      if(primary==='rta12v') warn.push('Een 12V-dakairco vraagt een passend accusysteem, bekabeling, zekeringen en laadcapaciteit. 12V betekent niet dat het energieverbruik laag is.');
      if((primary==='rta1700'||primary==='rta2200')&&power==='unknown') warn.push('Controleer of 230V beschikbaar is op de momenten waarop je de airco wilt gebruiken.');

      root.querySelector('.cv-ca-profile').textContent=profile;
      root.querySelector('.cv-ca-summary').textContent=primary?'Op basis van voertuiglengte, warmtebelasting, stroomvoorziening en reisstijl komt deze richting het beste uit de keuzehulp.':'Op basis van jouw voertuiglengte adviseren we geen automatische productmatch.';
      root.querySelector('.cv-ca-primary').innerHTML=primary?'<h3>Beste match</h3>'+card(primary,products[primary]?products[primary].title:'Beste match'):'<h3>Persoonlijke beoordeling aanbevolen</h3>';
      root.querySelector('.cv-ca-reason').innerHTML='<h3>Waarom dit advies?</h3><p>'+reason.join(' ')+'</p>';
      root.querySelector('.cv-ca-warning').innerHTML=warn.length?'<div class="cv-ca-warning"><strong>Controleer vóór bestelling</strong><br>'+warn.join(' ')+'</div>':'';
      root.querySelector('.cv-ca-alts').innerHTML=alts.length?'<h3>Alternatieven</h3>'+alts.map(function(k){return card(k,products[k]?products[k].title:k)+'<p class="cv-ca-alt-reason">'+altReason(k)+'</p>'}).join(''):'';
      root.querySelector('.cv-ca-check').innerHTML='<div class="cv-ca-note"><strong>CampVaro-check</strong><br>Een dakairco is een technische upgrade. Controleer altijd dakmaat, draagkracht, elektrische aansluiting en installatievoorwaarden voordat je bestelt. De installatie regel je met een installateur naar keuze.</div>';
      form.hidden=true;result.hidden=false;result.scrollIntoView({behavior:'smooth',block:'start'});
    }
    root.querySelector('.cv-ca-next').addEventListener('click',function(){if(!valid()){steps[idx].querySelector('label').scrollIntoView({behavior:'smooth',block:'center'});return}if(idx<steps.length-1)show(idx+1);else advise()});
    root.querySelector('.cv-ca-prev').addEventListener('click',function(){if(idx>0)show(idx-1)});
    root.querySelector('.cv-ca-restart').addEventListener('click',function(){form.reset();result.hidden=true;form.hidden=false;show(0)});
    show(0);
  }
  function boot(){document.querySelectorAll('[id^="CampVaroClimateAdvisor-"]').forEach(init)}
  document.addEventListener('DOMContentLoaded',boot);document.addEventListener('shopify:section:load',function(e){init(e.target.querySelector('[id^="CampVaroClimateAdvisor-"]')||e.target)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["campvaro-offgrid-energy-advisor"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root || root.dataset.cvInit) return;
    root.dataset.cvInit='1';
    var form=root.querySelector('.cv-ea__form'), result=root.querySelector('.cv-ea__result');
    if(!form) return;
    var steps=[].slice.call(root.querySelectorAll('.cv-step')), idx=0, products={};
    try{products=JSON.parse(root.querySelector('script[type="application/json"]').textContent);}catch(e){}

    var specs={
      ab120:{wh:1536,route:'allinone'},ab200:{wh:2560,route:'allinone'},ab300:{wh:3840,route:'allinone'},
      us280:{wh:3584,route:'installed',height:145},us320:{wh:4096,route:'installed',height:190},
      us540:{wh:6912,route:'installed',height:190},us700:{wh:8960,route:'installed',height:220}
    };

    function show(i){
      idx=i; steps.forEach(function(s,n){s.classList.toggle('is-active',n===i)});
      root.querySelector('.cv-prev').disabled=i===0;
      root.querySelector('.cv-next').textContent=i===steps.length-1?'Bekijk mijn advies':'Volgende';
      root.querySelector('.cv-ea__progress span').style.width=((i+1)/steps.length*100)+'%';
    }
    function valid(){return !!steps[idx].querySelector('input:checked');}
    function val(name){var x=form.querySelector('[name="'+name+'"]:checked');return x?x.value:null;}
    function card(key,label){
      var p=products[key];
      if(!p) return '<div class="cv-product-card"><div><strong>'+label+'</strong><br><small>Koppel dit product in de Theme Editor.</small></div></div>';
      return '<div class="cv-product-card">'+(p.image?'<img src="'+p.image+'" alt="">':'')+'<div><strong>'+label+'</strong><br><a class="button" href="'+p.url+'">Bekijk product</a></div></div>';
    }
    function capacityKey(route,need,space){
      if(route==='allinone'){
        if(need<=1536) return 'ab120';
        if(need<=2560) return 'ab200';
        if(need<=3840) return 'ab300';
        return null;
      }
      if(space==='lowprofile'){
        if(need<=3584) return 'us280';
        return null;
      }
      if(need<=3584) return 'us280';
      if(need<=4096) return 'us320';
      if(need<=6912) return 'us540';
      if(need<=8960) return 'us700';
      return null;
    }
    function alternatives(primary,route,space){
      var map={
        ab120:['ab200'],ab200:['ab120','ab300'],ab300:['ab200'],
        us280:['us320'],us320:['us280','us540'],us540:['us320','us700'],us700:['us540']
      };
      var a=(map[primary]||[]).slice(0,2);
      if(space==='lowprofile') a=a.filter(function(k){return k==='us280';});
      return a;
    }
    function advise(){
      var days=parseInt(val('days')||1,10), base=parseInt(val('basewh')||0,10);
      var ac=val('acload'), charging=val('charging'), routeChoice=val('route'), existing=val('existing'), space=val('space');
      var reserve=1.20, acFactor=(ac==='light'?1.05:ac==='medium'?1.10:1.15);
      var chargeFactor=(charging==='strong'?0.82:charging==='normal'?0.92:charging==='limited'?1.10:1.00);
      var need=Math.round(base*days*reserve*acFactor*chargeFactor);
      var route, primary, alts=[], profile='', reason=[], warning=[];

      if(routeChoice==='allinone') route='allinone';
      else if(routeChoice==='installed') route='installed';
      else {
        route=(existing==='yes'||space==='lowprofile'||space==='underseat')?'installed':'allinone';
      }

      if(route==='allinone'){
        profile='All-in-One Energy';
        reason.push('Je profiel past het best bij een complete energieoplossing met accu, 3.000 W omvormer en geïntegreerde laadmogelijkheden.');
        if(existing==='yes') warning.push('Je hebt al energiecomponenten. Controleer vóór bestelling of een AccuBox geen onnodige dubbele functies toevoegt.');
        if(ac==='extreme') warning.push('Je verwacht meer dan 3.000 W gelijktijdig. De AccuBox-route is dan niet automatisch passend; laat het piekvermogen beoordelen.');
      }else{
        profile='Integrated UnderSeat Energy';
        reason.push('Je profiel past beter bij een vaste LiFePO4-accu die onderdeel wordt van een geïntegreerd 12V-energiesysteem.');
        warning.push('Bij UnderSeat moeten omvormer, lader, laadbooster, zekeringen en bekabeling passend worden gedimensioneerd.');
        if(space==='unknown') warning.push('Meet de beschikbare inbouwruimte vóór bestelling. Passing is een harde voorwaarde.');
        if(space==='lowprofile') reason.push('Omdat bouwhoogte kritisch is, krijgt de LC 280 S LT met 145 mm hoogte voorrang.');
      }

      primary=capacityKey(route,need,space);
      if(primary){
        alts=alternatives(primary,route,space);
        if(primary==='ab120') reason.push('1.536 Wh sluit aan op een compacte energiebehoefte en houdt formaat en gewicht beperkt.');
        if(primary==='ab200') reason.push('2.560 Wh biedt een sterke middenweg tussen autonomie en formaat.');
        if(primary==='ab300') reason.push('3.840 Wh is de grootste AccuBox-capaciteit en past bij een hogere autonomievraag.');
        if(primary==='us280') reason.push('3.584 Wh gecombineerd met slechts 145 mm bouwhoogte maakt dit de low-profile keuze.');
        if(primary==='us320') reason.push('4.096 Wh biedt meer reserve dan de 280 S LT met een andere compacte voetafdruk.');
        if(primary==='us540') reason.push('6.912 Wh past bij een hoge energiebehoefte en een zwaar geïntegreerd systeem.');
        if(primary==='us700') reason.push('8.960 Wh is de maximale energiereserve binnen deze UnderSeat-selectie; ruimte en 60,4 kg gewicht moeten expliciet worden gecontroleerd.');
      }else{
        warning.push(route==='allinone'
          ?'De berekende behoefte ligt boven de 3.840 Wh van de grootste AccuBox. CampVaro adviseert de UnderSeat-route of een handmatige systeembeoordeling.'
          :'De combinatie van opslagbehoefte en/of beschikbare ruimte valt buiten een veilige automatische match. CampVaro adviseert een handmatige systeembeoordeling.');
      }

      if(charging==='limited') reason.push('Omdat je beperkt kunt bijladen, is extra opslagreserve zwaarder meegewogen.');
      if(charging==='strong') reason.push('Omdat je onderweg goed kunt bijladen, hoeft de accu niet uitsluitend op maximale autonomie te worden gekozen.');

      root.querySelector('.cv-result-profile').textContent=profile;
      root.querySelector('.cv-result-calc').textContent='Indicatieve opslagbehoefte op basis van jouw antwoorden: ca. '+need.toLocaleString('nl-NL')+' Wh. Dit is een keuze-indicatie, geen technische installatieberekening.';
      root.querySelector('.cv-result-primary').innerHTML=primary?'<h3>Beste match</h3>'+card(primary,products[primary]?products[primary].title:'Beste match'):'<h3>Persoonlijke beoordeling aanbevolen</h3>';
      root.querySelector('.cv-result-reason').innerHTML='<h3>Waarom dit advies?</h3><p>'+reason.join(' ')+'</p>';
      root.querySelector('.cv-result-warning').innerHTML=warning.length?'<div class="cv-warning"><strong>Controleer vóór bestelling</strong><br>'+warning.join(' ')+'</div>':'';
      function altReason(k){
        var reasons={
          ab120:'Compacter alternatief wanneer je energieverbruik lager blijkt en 1.536 Wh voldoende reserve biedt.',
          ab200:'Sterke middenweg wanneer je minder capaciteit nodig hebt dan de 300 S, maar meer reserve wilt dan de 120 S.',
          ab300:'Meer energiereserve wanneer je langer onafhankelijk wilt staan of je dagelijkse verbruik hoger uitvalt.',
          us280:'Low-profile alternatief wanneer minimale bouwhoogte belangrijker is en 3.584 Wh voldoende capaciteit biedt.',
          us320:'Compactere keuze wanneer minder opslagreserve voldoende is en deze voetafdruk beter in jouw voertuig past.',
          us540:'Meer capaciteit voor een hogere energiebehoefte, mits inbouwruimte en energiesysteem daarvoor geschikt zijn.',
          us700:'Maximale energiereserve voor langere autonomie en zwaarder gebruik; controleer ruimte, gewicht en systeemdimensionering.'
        };
        return reasons[k]||'Alternatief dat afhankelijk van jouw voertuig en gebruik beter kan passen.';
      }
      root.querySelector('.cv-result-alts').innerHTML=alts.length?'<h3>Alternatieven</h3>'+alts.map(function(k){return card(k,products[k]?products[k].title:k)+'<p class="cv-alt-reason">'+altReason(k)+'</p>'}).join(''):'';
      root.querySelector('.cv-result-next').innerHTML='<div class="cv-advice-note"><strong>CampVaro-check</strong><br>Twijfel je over inbouwruimte, piekvermogen of de combinatie met je bestaande energiesysteem? Laat CampVaro de match controleren voordat je bestelt.</div>';
      form.hidden=true; result.hidden=false; result.scrollIntoView({behavior:'smooth',block:'start'});
    }

    root.querySelector('.cv-next').addEventListener('click',function(){
      if(!valid()){steps[idx].querySelector('label').scrollIntoView({behavior:'smooth',block:'center'});return;}
      if(idx<steps.length-1) show(idx+1); else advise();
    });
    root.querySelector('.cv-prev').addEventListener('click',function(){if(idx>0)show(idx-1);});
    root.querySelector('.cv-restart').addEventListener('click',function(){form.reset();result.hidden=true;form.hidden=false;show(0);});
    show(0);
  }
  function boot(){document.querySelectorAll('[id^="CampVaroEnergyAdvisor-"]').forEach(init);}
  document.addEventListener('DOMContentLoaded',boot);
  document.addEventListener('shopify:section:load',function(e){init(e.target.querySelector('[id^="CampVaroEnergyAdvisor-"]')||e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
